
import { Component, Vue } from "vue-property-decorator";
import { SMCases } from "@/store";
import { TCase_Main_Applicant } from "@/models/cases";
import { API_ROUTES } from "@/utils/API";
import {
  SERVICE_STATUS,
  OA_STATUS,
  SERVICE_STEPS,
  TYPE_SERVICE,
  SERVICE_ALIASES,
  SKILLED_WORKER_INSIDE_SERVICE,
  SKILLED_WORKER_SERVICE,
} from "@/constants/services";

const NONE_LIST_TYPE = "none";

@Component({
  components: {
    Hello: () => import("./Highlight/Hello.vue"),
    OnExpertReview: () => import("./Highlight/OnExpertReview.vue"),
    Payment: () => import("./Highlight/Payment.vue"),
    CosCreation: () => import("./Highlight/CosCreation.vue"),
    AdditionalInfo: () => import("./Highlight/AdditionalInfo.vue"),
    ApplicationSubmission: () => import("./Highlight/ApplicationSubmission.vue"),
    VisaDecision: () => import("./Highlight/VisaDecision.vue"),
    ApprovedByHO: () => import("./Highlight/ApprovedByHO.vue"),
    RejectedByHO: () => import("./Highlight/RejectedByHO.vue"),
    AdditionalIDataAndDocuments: () => import("./Highlight/AdditionalIDataAndDocuments.vue"),
    IdChecks: () => import("./Highlight/IdChecks.vue"),
    FinalExpertReview: () => import("./Highlight/FinalExpertReview.vue"),
  },
})
export default class SwHighlight extends Vue {
  statuses = { ...SERVICE_STATUS, ...OA_STATUS };
  serviceSteps = SERVICE_STEPS;

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  init = false;

  get status() {
    return SMCases.caseStatus;
  }

  get onlineApplicationStatus() {
    return SMCases.onlineApplicationStatus;
  }

  get isApprovedByHo() {
    const { status, statuses, onlineApplicationStatus } = this;

    return status === statuses.complete && onlineApplicationStatus === statuses.approved_by_ho;
  }

  get isRejectedByHo() {
    const { status, statuses, onlineApplicationStatus } = this;

    return status === statuses.complete && onlineApplicationStatus === statuses.rejected_by_ho;
  }

  get stepName() {
    return SMCases.caseStepName;
  }

  caseHasTask = false;

  mainApplicant: TCase_Main_Applicant = {
    first_name: "",
    last_name: "",
    job_title: "",
  };

  get jobTitle() {
    return this.mainApplicant.job_title;
  }

  get name() {
    const { first_name, last_name } = this.mainApplicant;

    return first_name && last_name ? `${first_name} ${last_name}` : "";
  }

  get listType() {
    const { caseType } = this;

    if ([SKILLED_WORKER_SERVICE, SKILLED_WORKER_INSIDE_SERVICE].includes(caseType)) {
      return NONE_LIST_TYPE;
    }

    return null;
  }

  get commonWidgetProps() {
    const {
      jobTitle,
      name,
      caseType,
      listType,
      cosIsLoaded,
      paymentIsCompleted,
      getDependantVisaEnable,
    } = this;

    return {
      jobTitle,
      name,
      caseType,
      listType,
      cosIsLoaded,
      paymentIsCompleted,
      getDependantVisaEnable,
    };
  }

  risk = "";
  cosIsLoaded = false;
  paymentIsCompleted = false;

  async getCase() {
    try {
      const { data } = await this.axios.get(API_ROUTES.CASE_ID(this.caseId));

      if (!data) return;

      SMCases.setCaseStatus(data.status);

      SMCases.setCase(data);

      this.risk = data.final_decision;

      this.cosIsLoaded = data.cos_is_loaded;

      this.paymentIsCompleted = data.payment_is_completed;

      this.caseHasTask = data.has_task;
      SMCases.setHasTasks(data.has_task);

      this.mainApplicant = data.main_applicant;
      SMCases.setMainApplicant(data.main_applicant);
    } finally {
      this.init = true;
    }
  }

  get caseType() {
    let output = "";

    const aliases: TYPE_SERVICE = SERVICE_ALIASES;

    Object.keys(aliases).forEach((key: string) => {
      if (aliases[key] === SMCases.caseAlias) output = key;
    });

    return output;
  }

  get getDependantVisaEnable() {
    const service = (SMCases.case as unknown) as { can_start_dependant_case: boolean };

    return service.can_start_dependant_case === true;
  }

  mounted() {
    if (!this.init) this.getCase();
  }

  activated() {
    // NOTE: This approach helps us to refresh "tasks";
    // if (!this.init) this.getCase();
  }
}
